(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-thank-you-landing"] && !Shopify.designMode) return;
  try {
    
  // <tp-copy-button data-copy-from="<id>"> — kopiert den Text des Ziel-Elements in die Zwischenablage.
  class TpCopyButton extends HTMLElement {
    constructor() {
      super();
      this._onActivate = this._onActivate.bind(this);
      this._onKey = this._onKey.bind(this);
    }
    connectedCallback() {
      if (!this.hasAttribute('role')) { this.setAttribute('role', 'button'); }
      if (!this.hasAttribute('tabindex')) { this.setAttribute('tabindex', '0'); }
      this.addEventListener('click', this._onActivate);
      this.addEventListener('keydown', this._onKey);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onActivate);
      this.removeEventListener('keydown', this._onKey);
      if (this._timer) { clearTimeout(this._timer); }
    }
    _onActivate() { this._copy(); }
    _onKey(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._copy(); } }
    _copy() {
      var id = this.getAttribute('data-copy-from');
      var src = id && document.getElementById(id);
      var text = src ? (src.innerText || src.textContent) : '';
      if (!text || !navigator.clipboard) { return; }
      var self = this;
      navigator.clipboard.writeText(text).then(function () {
        var original = self.innerHTML;
        self.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"></polyline></svg> Kopiert!';
        self.classList.add('tp-thankyou-card__coupon-copy--success');
        self._timer = setTimeout(function () {
          self.innerHTML = original;
          self.classList.remove('tp-thankyou-card__coupon-copy--success');
        }, 2000);
      }).catch(function (err) { console.error('Fehler beim Kopieren: ', err); });
    }
  }
  if (!customElements.get('tp-copy-button')) { customElements.define('tp-copy-button', TpCopyButton); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-methods"] && !Shopify.designMode) return;
  try {
    
  // <tp-payment-nav> — Smooth-Scroll für Anker-Links (.tp-payment-card--link) innerhalb der Section.
  class TpPaymentNav extends HTMLElement {
    constructor() { super(); this._onClick = this._onClick.bind(this); }
    connectedCallback() {
      this._root = this.closest('section') || document;
      this._root.addEventListener('click', this._onClick);
    }
    disconnectedCallback() {
      if (this._root) { this._root.removeEventListener('click', this._onClick); }
    }
    _onClick(e) {
      var link = e.target.closest && e.target.closest('.tp-payment-card--link');
      if (!link) { return; }
      var id = (link.getAttribute('href') || '').substring(1);
      var target = id && document.getElementById(id);
      if (!target) { return; }
      e.preventDefault();
      var offset = parseInt(this.getAttribute('data-offset'), 10) || 100;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
  if (!customElements.get('tp-payment-nav')) { customElements.define('tp-payment-nav', TpPaymentNav); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-ecom-team"] && !Shopify.designMode) return;
  try {
    
  // <tp-vcard-button> — eigenständiges Web Component (self-init/self-cleanup, kein Sections.js).
  // Baut beim Klick/Enter aus den data-Attributen eine .vcf-Visitenkarte und lädt sie herunter.
  class TpVcardButton extends HTMLElement {
    constructor() {
      super();
      this._onActivate = this._onActivate.bind(this);
      this._onKey = this._onKey.bind(this);
    }

    connectedCallback() {
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
      this.addEventListener('click', this._onActivate);
      this.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onActivate);
      this.removeEventListener('keydown', this._onKey);
    }

    _onActivate() {
      this._download();
    }

    _onKey(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._download();
      }
    }

    _esc(s) {
      return (s || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
    }

    _build() {
      const d = this.dataset;
      const name = d.name || '';
      const parts = name.split(' ');
      const last = parts.length > 1 ? parts.pop() : '';
      const first = parts.join(' ');
      const lines = ['BEGIN:VCARD', 'VERSION:3.0',
        'N:' + this._esc(last) + ';' + this._esc(first) + ';;;',
        'FN:' + this._esc(name),
        'ORG:' + this._esc(d.org || 'Talk-Point GmbH')];
      if (d.role) lines.push('TITLE:' + this._esc(d.role));
      if (d.email) lines.push('EMAIL;TYPE=WORK:' + d.email);
      if (d.phone) lines.push('TEL;TYPE=WORK,VOICE:' + d.phone);
      lines.push('URL:https://talk-point.de');
      lines.push('END:VCARD');
      return lines.join('\r\n');
    }

    _download() {
      try {
        const v = this._build();
        const fname = (this.dataset.name || 'kontakt').replace(/\s+/g, '_') + '.vcf';
        const blob = new Blob([v], { type: 'text/vcard;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
      } catch (e) {
        try {
          window.location.href = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(this._build());
        } catch (err) {
          console.error('vCard download failed', err);
        }
      }
    }
  }

  if (!customElements.get('tp-vcard-button')) {
    customElements.define('tp-vcard-button', TpVcardButton);
  }

  } catch(e) { console.error(e); }
})();
})();
